<template>
  <v-container class="admin-loading-container" fluid>
    <v-layout align-center justify-start column fill-height>
      <v-flex class="top-logo">
        <img v-if="tenant.logo" class="logo" :src="tenant.logo" />
        <img v-else class="logo" src="@/assets/logo-w.png" />
      </v-flex>
      <v-flex xs12>
        <v-card class="admin-loading">
          <h2 class="primary--text">{{ tenant.appName || appname }}</h2>
          <h3 class="grey--text">{{ slogan }}</h3>
          <p>{{ message }}</p>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "admin-login",
  data: function () {
    return {
      message: "加载中...",
      appname: this.$const.appName,
      slogan: this.$const.slogan,
    };
  },
  computed: {
    tenant() {
      return this.$store.state.tenant;
    },
    dark() {
      return this.$store.state.dark;
    },
  },
};
</script>

<style scoped>
.admin-loading-container {
  background: var(--v-primary-base);
}

.admin-loading-container .top-logo {
  flex-grow: 0;
  margin-top: 36px;
}

.top-logo img.logo {
  height: 30px;
  width: auto;
  display: inline-flex;
}

.admin-loading {
  max-width: 600px;
  text-align: center;
  padding: 40px 65px;
  margin-top: 40px;
}

.admin-loading h2 {
  font-size: 24px;
  line-height: 1;
}

.admin-loading h3 {
  font-size: 16px;
  font-weight: normal;
  margin-top: 20px;
}

.admin-loading p {
  margin-top: 20px;
  margin-bottom: 0;
}
</style>


